import { PrizeDTO, PrizeRequestDTO } from '@/models';
import { axiosBase } from './axios-base';

const buildPrizeRequestFormData = (requestData: PrizeRequestDTO): FormData => {
  const formData = new FormData();
  formData.append('id', requestData.id ? requestData.id.toString() : '');
  formData.append('name', requestData.name);
  formData.append('type', requestData.type);
  formData.append('description', requestData.description || '');
  if (requestData.image) {
    formData.append('image', requestData.image);
  }
  return formData;
};

export const fetchPrizes = (): Promise<{ data: PrizeDTO[] }> => {
  return axiosBase.get('/api/prizes');
};

export const createOrUpdatePrize = (requestData: PrizeRequestDTO): Promise<{ data: PrizeDTO }> => {
  const body = buildPrizeRequestFormData(requestData);
  return axiosBase.put('/api/prize', body);
};
